var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rp-footer-wrapper"},[_c('div',[_vm._v("Report generated at : "+_vm._s(_vm.currentTime))]),_c('div',[_vm._v(_vm._s(_vm.page)+"/"+_vm._s(_vm.lastPage))])])
}
var staticRenderFns = []

export { render, staticRenderFns }